export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/heic', 'image/heif'];
